// Accessible roving tablist for the drawer record (recordOnly) view.
// Panels stay mounted (hidden) so open editors/drafts survive tab switches.
import { useRef } from "react";
import { T } from "../../../app/tokens.js";

export function RecordTabs({ tabs, active, onChange, idBase = "record-tab" }) {
  const refs = useRef({});
  const onKey = (e) => {
    const i = tabs.findIndex((t) => t.key === active);
    let next = null;
    if (e.key === "ArrowRight") next = tabs[(i + 1) % tabs.length];
    else if (e.key === "ArrowLeft") next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (e.key === "Home") next = tabs[0];
    else if (e.key === "End") next = tabs[tabs.length - 1];
    if (!next) return;
    e.preventDefault();
    onChange(next.key);
    refs.current[next.key]?.focus();
  };
  return (
    <div role="tablist" aria-label="Project record sections" data-testid="record-tabs" onKeyDown={onKey}
      style={{ display: "flex", gap: 2, padding: 3, marginBottom: 12, background: T.lightGray, border: `1px solid ${T.border}`, borderRadius: 10, overflowX: "auto" }}>
      {tabs.map((t) => {
        const sel = t.key === active;
        return (
          <button key={t.key} ref={(el) => { refs.current[t.key] = el; }} type="button" role="tab"
            id={`${idBase}-${t.key}`} aria-selected={sel} aria-controls={`${idBase}-panel-${t.key}`} tabIndex={sel ? 0 : -1}
            data-testid={`record-tab-${t.key}`} onClick={() => onChange(t.key)}
            style={{ flex: "1 1 0", minWidth: 84, border: 0, borderRadius: 8, padding: "7px 10px", cursor: "pointer", whiteSpace: "nowrap",
              fontSize: T.fsSm, fontWeight: T.fwBold, background: sel ? T.card : "transparent", color: sel ? T.projectsHubNavy : T.mid,
              boxShadow: sel ? `0 0 0 1px ${T.border}` : "none" }}>
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export function RecordTabPanel({ tabKey, active, idBase = "record-tab", children }) {
  return (
    <div role="tabpanel" id={`${idBase}-panel-${tabKey}`} aria-labelledby={`${idBase}-${tabKey}`} data-testid={`record-panel-${tabKey}`}
      hidden={tabKey !== active} tabIndex={tabKey === active ? 0 : -1} style={{ outline: "none" }}>
      {children}
    </div>
  );
}
